function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNewPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 3.83h10.368c.573 0 1.037.465 1.037 1.037v1.037H7.123v2.074h12.442V16l2.074-3V4.867a3.11 3.11 0 00-3.11-3.11H8.16a3.11 3.11 0 00-3.11 3.11v20.737a3.11 3.11 0 003.11 3.11H19.5l-1.364-2.073H8.16a1.037 1.037 0 01-1.037-1.037V4.868c0-.573.465-1.037 1.037-1.037z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.354 22.493h-5.23v2.074H16l-3.646-2.074zM23.092 14.342c.078-.456.738-.456.816 0a8.295 8.295 0 006.604 6.721l.074.43.071-.401c.457.078.457.738 0 .816a8.297 8.297 0 00-6.749 6.749c-.078.456-.738.456-.816 0a8.297 8.297 0 00-6.75-6.75c-.427-.072-.454-.657-.08-.794l.08-.021a8.297 8.297 0 006.75-6.75zm.408 4.263a10.31 10.31 0 01-2.895 2.895 10.311 10.311 0 012.895 2.893 10.31 10.31 0 012.893-2.893 10.311 10.311 0 01-2.893-2.895zm7.157 2.486l-.071.403-.073-.43.144.027z",
    fill: props.color
  }));
}

export default SvgIconNewPhoneFilled;